import { TranslationObject } from '@ngx-translate/core';

export class Location {
  geoCode: string;
  geoType: string;
  title: TranslationObject = {};
  boundingBox?: string;
  countryCode?: string;

  constructor(geoCode: string, geoType: string, title: TranslationObject, boundingBox?: string, countryCode?: string) {
    this.geoCode = geoCode;
    this.geoType = geoType;
    this.title = title;
    this.boundingBox = boundingBox;
    this.countryCode = countryCode;
  }

  isCustomLocation(): boolean {
    return this.geoType.trim().toLowerCase() === 'custom';
  }
}
